import { createSelector } from 'reselect';

import { AppState } from '../../../../../../store/models/app-state';

const getSupplierDetail = (state: AppState) => state.contactsAndOrganizations.suppliers.supplierDetail;

export const supplierAttributeMappingSelector = createSelector(
    getSupplierDetail,
    state => state.attributes.supplierMappings
);
